import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import apiClient from '../../api/apiClient';

let cachedHomeMeta = null;
let homeMetaPromise = null;

const fetchHomeMeta = () => {
  if (cachedHomeMeta) return Promise.resolve(cachedHomeMeta);
  if (!homeMetaPromise) {
    homeMetaPromise = apiClient.get('/web-pages/frontend-pages/home')
      .then(res => {
        if (res.data?.success && res.data?.data) {
          cachedHomeMeta = {
            meta_title: res.data.data.meta_title || res.data.data.title || '',
            meta_desc: res.data.data.meta_desc || '',
            meta_keywords: res.data.data.meta_keywords || ''
          };
        }
        return cachedHomeMeta;
      })
      .catch(err => {
        console.error('Error fetching home meta for SEO:', err);
        return null;
      });
  }
  return homeMetaPromise;
};

const SEO = ({
  title,
  description,
  keywords,
  author = "Mangoloops",
  canonical = "https://mangoloops.com/",
  robots = "index, follow",
  ogTitle,
  ogDescription,
  ogImage = "https://mangoloops.com/logo-mangoloops.png",
  ogUrl = "https://mangoloops.com/",
  ogType = "website",
  twitterCard = "summary_large_image",
  twitterTitle,
  twitterDescription,
  twitterImage = "https://mangoloops.com/logo-mangoloops.png",
}) => {
  const [homeMeta, setHomeMeta] = useState(cachedHomeMeta);

  useEffect(() => {
    if (!cachedHomeMeta) {
      fetchHomeMeta().then(meta => {
        if (meta) setHomeMeta(meta);
      });
    }
  }, []);

  const finalTitle = title || homeMeta?.meta_title || "Mangoloops";
  const finalDescription = description || homeMeta?.meta_desc || "";
  const finalKeywords = (keywords !== undefined && keywords !== null && keywords !== "")
    ? keywords
    : (homeMeta?.meta_keywords || "");

  const finalOgTitle = ogTitle || finalTitle;
  const finalOgDescription = ogDescription || finalDescription;
  const finalTwitterTitle = twitterTitle || finalTitle;
  const finalTwitterDescription = twitterDescription || finalDescription;

  return (
    <Helmet>
      {/* Standard metadata tags */}
      <title>{finalTitle}</title>
      <meta name="title" content={finalTitle} />
      {finalDescription ? <meta name="description" content={finalDescription} /> : null}
      {finalKeywords ? <meta name="keywords" content={finalKeywords} /> : null}
      <meta name="author" content={author} />
      <meta name="robots" content={robots} />
      <link rel="canonical" href={canonical} />

      {/* Open Graph tags */}
      <meta property="og:title" content={finalOgTitle} />
      <meta property="og:description" content={finalOgDescription} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={ogUrl} />
      <meta property="og:type" content={ogType} />

      {/* Twitter Card tags */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={finalTwitterTitle} />
      <meta name="twitter:description" content={finalTwitterDescription} />
      <meta name="twitter:image" content={twitterImage} />
    </Helmet>
  );
};

export default SEO;
